module.exports = __webpack_public_path__ + "img/pamphlet_thumb01@3x.20d58694.png";